import { styled } from 'styled-components';
import {useEffect, useRef, useState} from "react";
import {Button} from "@/components/ui/Button.tsx";
import {IoChevronDown} from "react-icons/io5";
import {DeleteConfirmDialog} from "@/components/DeleteConfirmDialog.tsx";

const MenuContainer = styled.div`
  position: absolute;
  top: 120%;
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  z-index: 1000;
  min-width: 200px;
`;

const MenuItem = styled.div`
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  
  &:hover {
    background: rgba(77, 105, 156, 0.1);
  }
`;

interface StepContextMenuProps {
    onAddAbove: () => void;
    onAddBelow: () => void;
    duplicateStep: () => void;
    onDelete: () => void;
    canAddAbove?: boolean;
    canAddBelow?: boolean;
    step: number
}

export const StepContextMenu = ({
   onAddAbove,
   onAddBelow,
   onDelete,
   canAddAbove,
   canAddBelow,
   duplicateStep,
   step
}: StepContextMenuProps) => {
    const [isVisible, setIsVisible] = useState(false);
    const [isDeleteOpen, setIsDeleteOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement | null>(null);

    const handleMenuSelect = (callback: () => void) => {
        setIsVisible(false);
        callback();
    }

    const openDeleteModal = () => {
        setIsVisible(false);
        setIsDeleteOpen(true)
    }

    const handleDelete = () => {
        setIsDeleteOpen(false);
        onDelete();
    }

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setIsVisible(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <>
            <Button
                variant="ghost"
                padding="3px 10px"
                style={{fontSize: '14px'}}
                className="operator-button"
                onClick={() => setIsVisible(true)}
            >
                <IoChevronDown size={14}/>
            </Button>
            {isVisible && (
                <div ref={menuRef}>
                    <MenuContainer>
                        {canAddAbove && <MenuItem onClick={() => handleMenuSelect(onAddAbove)}>Добавить строку выше</MenuItem>}
                        {canAddBelow && <MenuItem onClick={() => handleMenuSelect(onAddBelow)}>Добавить строку ниже</MenuItem>}
                        {canAddBelow && <MenuItem onClick={() => handleMenuSelect(duplicateStep)}>Дублировать шаг</MenuItem>}
                        <MenuItem onClick={openDeleteModal}>Удалить строку</MenuItem>
                    </MenuContainer>
                </div>
            )}
            <DeleteConfirmDialog
                isOpen={isDeleteOpen}
                setIsOpen={setIsDeleteOpen}
                onConfirm={handleDelete}
                onCancel={() => setIsDeleteOpen(false)}
                step={step}
            />
        </>
    );
};
